import { PageShell } from '@components'
import { DashboardAdmin, DashboardStaff } from '@dashboard'
import cn from '@integrations/classnames'
import { CustomerRoles, selectCurrentUserRole, useAppSelector } from 'mmfintech-backend-api'

function DashboardView() {
  const customerRole = useAppSelector(selectCurrentUserRole)

  return (
    <PageShell className={cn('dashboard-wrapper')}>
      {customerRole === CustomerRoles.STAFF ? <DashboardStaff /> : <DashboardAdmin />}
    </PageShell>
  )
}

export default DashboardView
